import React from 'react';
const MinimizeSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      {...props}
      className={className}
    >
      <path
        d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z'
        stroke='#0744E1'
        strokeWidth='1.2'
      />
      <path
        d='M11.4016 9H6.60156'
        stroke='#0744E1'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default MinimizeSVG;
